var map = {
	"./NSW-shield-logo.svg": "MlcH",
	"./NSW-top-header-left.svg": "orn6",
	"./NSW-top-header-right.svg": "UuzG",
	"./QLD-shield-logo.svg": "RvdW",
	"./QLD-top-header-left.svg": "nX/f",
	"./QLD-top-header-right.svg": "S5Ic",
	"./codesports.svg": "sd/s",
	"./logo-NSW.svg": "ITF2",
	"./logo-QLD.svg": "6Gc7"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "KZtR";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images ^\.\/.*\.svg$
// module id = KZtR
// module chunks = 1